import axios from "axios";
import { API_BASE_URL } from "./BaseURL";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const galleryService = {
  

  uploadImages: async (files) => {
    const formData = new FormData();
  
    const fileArray = Array.isArray(files) ? files : [files];
    

    fileArray.forEach((file) => {
      formData.append("images", file);
    });

    const res = await api.post("/gallery/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  },

 
  getAllImages: async (params = {}) => {
    const res = await api.get("/gallery", { params });
    return res.data;
  },


  getSingleImage: async (id) => {
    const res = await api.get(`/gallery/image/${id}`);
    return res.data;
  },

 
  deleteSingleImage: async (id) => {
    const res = await api.delete(`/gallery/image/${id}`);
    return res.data;
  },


  deleteAllImages: async () => {
    const res = await api.delete("/gallery", {
      data: { confirm: "yes" },
    });
    return res.data;
  },
};

export default galleryService;